<template>
  <div class="page_ticket">
    <div>
      <img src="~@static/funding_cpunk/creation/ad_pic.png" width="100%" alt="" />
    </div>
    <div class="cpunk_page">
      <div class="rank">
        <div class="list">
          <div class="item" v-for="(item, index) in list" :key="index">
            <div class="one">{{ item.no }}</div>
            <div class="two">
              <img :src="item.headimgurl" alt="" />
              <span>{{ item.nickname }}</span>
            </div>
            <div class="three">{{ item.score }}</div>
          </div>
        </div>
      </div>
      <div class="create_btn_s1" @click="toAllPlan"># 查看全部夜计划 #</div>
      <div class="create_btn_s1" @click="toMyPlan"># 我的夜计划 #</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
    }
  },
  mounted() {
    this.$request.post(this.$apiConfig.cyberRank).then(res => {
      let resData = res.data
      if (resData.code == 0 && resData.data) {
        this.list = resData.data.slice(0, 5)
      }
    })
  },
  methods: {
    toAllPlan() {
      this.$router.push(`/fundingnew/explore`)
    },
    toMyPlan() {
      this.$router.push(`/fundingnew/my/submissions`)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@styles/cpunk.scss';
.cpunk_page {
  padding-bottom: 60px;
}
.rank {
  position: relative;
  width: pxtow(692);
  height: pxtow(815);
  margin: 0 auto;
  background: url('~@static/funding_cpunk/rank.png') no-repeat 50% 50%;
  background-size: 100% auto;
  .list {
    position: absolute;
    left: pxtow(90);
    top: pxtow(263);
    width: pxtow(460);
    .item {
      display: flex;
      align-content: center;
      border-bottom: 1px solid #f2f42a;
      height: pxtow(40);
      padding: pxtow(35) pxtow(10) pxtow(10);
      box-sizing: content-box;
    }
    .one {
      width: pxtow(120);
    }
    .two {
      position: relative;
      flex: 1;
      overflow: hidden;
      img {
        position: absolute;
        left: 0;
        top: 0;
        width: pxtow(40);
        height: pxtow(40);
        margin-right: pxtow(12);
        border-radius: 100%;
      }
      span {
        display: block;
        padding-left: pxtow(52);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .three {
      width: pxtow(100);
      text-align: right;
    }
  }
}
.create_btn_s1 {
  margin-top: pxtow(35);
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/ticket.vue